import { Divider } from '@mui/material';
import { FaHome } from 'react-icons/fa';
import MenuLink from '~/components/layouts/MenuLink';
import { getLcn } from '~/utils/labeled-classnames';
import { chartNewPath } from '../../routes/paths';
import { PiGridFourFill } from 'react-icons/pi';
import { MdAddBox } from 'react-icons/md';

export default function SidebarContent() {
  const lcn = getLcn({
    sidebarContent: 'md:my-4 flex flex-col ',
  });

  return (
    <div className={lcn.sidebarContent}>

      <MenuLink to={`/`} icon={<FaHome />} > Home </MenuLink>
      <MenuLink to={`/`} icon={<PiGridFourFill />} > Chart List</MenuLink>
      <MenuLink to={chartNewPath} icon={<MdAddBox />} > New Chart </MenuLink>

      <Divider />

    </div>
  );
}; 